module.exports = __webpack_public_path__ + "img/credit-card.5d1fc9a0.png";